<template>
  <div>
    <v-btn
      fab
      bottom
      right
      color="pink"
      dark
      fixed
      @click.stop="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="800px">
      <v-card>
        <v-container grid-list-sm class="pa-4">
          <v-layout row wrap>
            <v-flex xs12 align-center justify-space-between>
              <v-select
                :items="servicesList"
                label="Select products"
                v-model="selectedServices"
                item-text="name"
                item-value="id"
                multiple
                return-object
              >
                <template slot="item" slot-scope="props">
                  {{ props.item.name }} - {{ props.item.category.name }}
                </template>
                <template slot="selection" slot-scope="props">
                  {{ props.item.name }} - {{ props.item.category.name }}
                </template>
              </v-select>
            </v-flex>
            <v-flex xs12 align-center justify-space-between v-for="(service, i) in selectedServices" :key="i">
              <v-layout>
                <v-flex xs3>
                  {{ service.name }} in quantity
                </v-flex>
                <v-flex xs2>
                  <v-text-field type="number" v-model="service.amount"></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn color="primary" @click="saveNew">Save</v-btn>
          <v-btn flat @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import casesAPI from '@/api/resources/cases'
  import resourcesMixin from '@/mixins/Resources'
  import { mapGetters } from 'vuex'
  import _ from 'lodash'

  export default {
    mixin: [ resourcesMixin ],
    data () {
      return {
        resources: 'services',
        dialog: false,
        servicesList: [],
        selectedServices: [],
        caseModel: null
      }
    },
    props: {
      casesid: {
        type: Number,
        required: true
      }
    },
    computed: {
      ...mapGetters({
        allProducts: 'allProducts'
      })
    },
    methods: {
      saveNew () {
        let mergedServices = _.unionBy(this.caseModel.services, this.selectedServices, 'id')
        mergedServices = _.reduce(mergedServices, (result, value, key) => {
          result[key] = {
            id: value.id,
            amount: parseInt(value.pivot ? value.pivot.quantity : value.amount)
          }
          return result
        }, [])

        casesAPI.attachServicesToCase(this.casesid, mergedServices).then(result => {
          this.$store.dispatch('loadAllCases')
          this.$emit('resource-attached')

          this.dialog = false
        })
      },
      loadListing () {
        this.selectedServices = []

        this.$store.dispatch('loadCase', this.casesid).then((caseModel) => {
          this.caseModel = caseModel
          this.servicesList = _.differenceWith(this.allProducts, caseModel.services, (prod, newProd) => prod.id === newProd.id)
        })
      }
    },
    created () {
      this.loadListing()
    }
  }
</script>



// WEBPACK FOOTER //
// AttachServicesToCaseButton.vue?31af4790